/**
 *
 * We actually don't have a staging environment for the web. Due to
 * security policies we cannot connect to hallosunan from the local machines.
 *
 */
export default {};
